import React, { useState } from "react";
import { useEffect, Fragment } from 'react';
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container, Modal, Spinner, ModalFooter, ModalBody,
  Row,
  Col, FormGroup, Input, Label, FormText, Collapse
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import auth from "authProvider";


const Time = (props) => {
  const history = useHistory();
  const [pos, setPos] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editloading, setEditloading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [time, setTime] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [reload, setReload] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [editsucess, setEditsucess] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [status, setStatus] = useState(1);
  const [values, setValues] = useState(new Date());


  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  useEffect(() => {
    let token = localStorage.getItem('token');
    dataProvider.getList('slots', { params: { pagination: { page: page, perPage: 10 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        if (data.length < 10) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setTime(data);
      })
      .catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }, [props, reload]);

  const handleClickOpen = (index) => {
    setOpen(true);
    setPos(index)
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = values => {
    setLoading(true)
    dataProvider.create('slots', { params: { ...values, status: status } })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => Pushcreate(), 2000);

      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });
  };
  const removeData = (id, index) => {
    dataProvider.delete('slots', { id: id });
    let timeArr = time;
    timeArr.splice(index, 1);
    setTime(timeArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const onSubmit_update = (values, id) => {
    setOpen(false);
    setEditloading(true)
    dataProvider.update('slots', { id: time[pos].id, params: { ...values, status: status } })
      .then(({ data }) => {
        setEditsucess(true)
        setTimeout(() => Pushedit(), 2000);
        setEditloading(false)
      })
      .catch(error => {
        setEditloading(false)
        alert(error.message)
      });
  };
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    setReload(!reload);
  }
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const Pushcreate = () => {
    setSucess(false)
    window.location.reload();
  }
  const Pushedit = () => {
    setEditsucess(false)
    window.location.reload();
  }
  const onChangeStatus = (status) => {
    setStatus(status)

  }
  const pickdatetime = (val) => {
    setValues(val)

  }
  let today = new Date();
  const required = value => (value ? undefined : 'Required')
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white', marginLeft: 10 }}>TIME</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="7">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                <div style={{ alignContent: 'flex-start' }}><h3 style={{ fontWeight: 'bold', color: '#5d5d49' }}>TIME</h3></div>
                <div style={{ alignContent: 'flex-end' }}>
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">slots</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {time && time.length > 0 && (
                    time.map((time, index) => (
                      <tr>
                        <td>{time?.slot}</td>
                        <td style={{ flexDirection: 'row', display: 'flex' }}>
                          <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => handleClickOpen(index)} ><IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="edit" /></Button>
                          <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} onClick={() => setConfirmOpen({ visible: true, id: time.id, index: index })}> <IcomoonReact iconSet={iconSet} color="#ccc" size={15} icon="delete" /></Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <Modal isOpen={confirmOpen.visible} size="sm">
                  <div className="modal-header"></div>
                  <ModalBody style={{ color: 'red', padding: 0, paddingLeft: 20 }}>DO YOU WANT DELETE THIS  ?</ModalBody>
                  <ModalFooter >
                    <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                      NO
                    </Button>
                    <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                      YES
                    </Button>
                  </ModalFooter>
                </Modal>
              </Table>
            </Card>
          </Col>
          <Col xl="5">
            <Card className="shadow" style={{ borderRadius: 10 }}>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 18, fontWeight: 'bold', color: '#5e5d49' }} className="mb-0">CREATE NEW TIME</h3>
                  </div>
                </Row>
              </CardHeader>
              <Form
                onSubmit={onSubmit}
                validate={values => {
                  const errors = {};
                  if (!values.slot) {
                    errors.slot = "Required";
                  }
                  return errors;
                }}
                render={({ handleSubmit, reset, form }) => (
                  <form onSubmit={handleSubmit} style={{ paddingTop: '0px', paddingLeft: 20, paddingRight: 30 }} >
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }}>
                            <Label style={{ fontSize: ' 0.9rem' }} for="service">Time slot</Label>
                            <Field name="slot" validate={required} >
                              {({ input, meta, error }) => (
                                <div>
                                  <Input
                                    {...input}
                                    style={{ color: 'black', borderRadius: 10 }}
                                    type="text"
                                    placeholder=" Enter Time interval"
                                  />
                                  {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        <Col lg="12">
                          <FormGroup style={{ marginBottom: 10 }}>
                            <Label style={{ fontSize: ' 0.9rem' }} >Status</Label>
                            <Field name="status">
                              {({ input, meta }) => (
                                <div>
                                  <Input required type="select" defaultValue={time[pos]?.status} onChange={(e) => onChangeStatus(e.target.value)} style={{ color: '#6c6250', borderRadius: 10 }}>
                                    <option selected={1} value="1">Enabled</option>
                                    <option value="0">Disabled</option>
                                  </Input>
                                </div>
                              )}
                            </Field>
                          </FormGroup>
                        </Col>
                        {/* <Col lg="12" style={{marginTop:20}}>
                          <Input
                            value={values}
                            onChange={(e)=>pickdatetime(e.target.value)}
                            type="datetime-local" 
                            min={today}
                          // min={new Date()}
                          // min="2022-02-06T22:22:55"
                          >
                        </Input>
                        </Col> */}
                      </Row>
                    </div>
                    <Row>
                      <Col lg="12">
                        <div style={{ marginLeft: 20, paddingLeft: 10, paddingRight: 10 }}>
                          <Button disabled={loading} type="submit" style={{
                            backgroundColor: 'rgb(4 64 87)', color: 'white', width: '100%', border: 0, marginBottom: 25,
                            marginTop: '10px', padding: 15, borderRadius: 10
                          }}>
                            {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}SUBMIT</Button>{' '}
                        </div>
                      </Col>
                    </Row>
                  </form>
                )}
              />
            </Card>
          </Col>
        </Row>
      </Container>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={open}
        >
          <div onClick={() => setOpen(false)} style={{ backgroundColor: 'rgb(193 193 125)', cursor: 'pointer', width: '30px', height: '30px', position: 'absolute', right: '-10px', top: '-10px', borderRadius: '50%' }}>
            <IcomoonReact iconSet={iconSet} onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(4 64 87)', color: 'white', paddingBottom: 20 }}>
            <label style={{ marginTop: 20 }}>EDIT TIME</label>
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setOpen(false)}
          >
            <IcomoonReact iconSet={iconSet} color="white" size={14} icon="close" />
          </button>
          <div>
            <Form
              onSubmit={onSubmit_update}
              validate={values => {
                const errors = {};

                if (!values.slot) {
                  errors.slot = "Required";
                }
                return errors;
              }}
              render={({ handleSubmit, reset, form }) => (
                <form onSubmit={handleSubmit} style={{ padding: '10px' }}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.8125rem' }} > Time</Label>
                          <Field name="slot" initialValue={time[pos].slot ? time[pos].slot : null}>
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  style={{ color: 'black' }}
                                  type="text"
                                  name="slot"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <FormGroup style={{ marginBottom: 10 }}>
                          <Label style={{ fontSize: ' 0.9rem', color: '#6c6250' }} >Status</Label>
                          <Field name="status">
                            {({ input, meta }) => (
                              <div>
                                <Input type="select" defaultValue={time[pos]?.status} onChange={(e) => onChangeStatus(e.target.value)} style={{ color: '#6c6250', borderRadius: 10 }}>
                                  <option value="1">Enabled</option>
                                  <option value="0">Disabled</option>
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <Row style={{ marginTop: 20, marginBottom: 20 }}>
                    <Col lg="12">
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button disabled={editloading} type="submit" style={{ backgroundColor: 'rgb(4 64 87)', color: 'white', width: '50%', border: 0 }}>
                          {editloading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}UPDATE</Button>{' '}
                      </div>
                    </Col>
                  </Row>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={editsucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Updated successfully!</ModalBody>
      </Modal>
    </>
  );
};

export default Time;

